import React from "react";

export function useServiceWorker() {
  const [registration, setRegistration] = React.useState<ServiceWorkerRegistration | null>(null);
  const [updateAvailable, setUpdateAvailable] = React.useState(false);

  React.useEffect(() => {
    if (!("serviceWorker" in navigator)) {
      return;
    }

    let refreshing = false;

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) {
        return;
      }

      refreshing = true;
      window.location.reload();
    });

    navigator.serviceWorker
      .register("/sw.js")
      .then((nextRegistration) => {
        setRegistration(nextRegistration);

        if (nextRegistration.waiting) {
          setUpdateAvailable(true);
        }

        nextRegistration.update().catch(() => undefined);
        nextRegistration.addEventListener("updatefound", () => {
          const worker = nextRegistration.installing;

          worker?.addEventListener("statechange", () => {
            if (worker.state === "installed" && navigator.serviceWorker.controller) {
              setUpdateAvailable(true);
            }
          });
        });
      })
      .catch(() => undefined);
  }, []);

  function applyUpdate() {
    registration?.waiting?.postMessage({ type: "SKIP_WAITING" });
  }

  return { applyUpdate, updateAvailable };
}
